// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
    color: white;
    background-color: black;
    width: 90vw;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.checkout-page-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
}
.middle-container {
    display: flex;
    /* flex-direction: column; */
    justify-content: space-around;
    background-color: white;
    font-family: "Roboto";
    border:1px solid #DDDDDD;
    padding: 8px;
    border-radius: 6px;

}

.middle-container1 {
    display: flex;
    background-color: white;
    margin-bottom: 6px;
    margin-right: 8px;
    margin-top: 10px;

}

.heading {
    font-size: 20px;
    font-family: "Roboto";
    color: black;
    align-self: flex-start;
}

.table-container {
    /* background-color: #e6eff0; */

    /* padding:30px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background-color: red; */
    width: 60%;
    height: auto;
    /* box-shadow: 0px 1px 5px 1px black; */
    border-radius: 1px;

}

.button-container {
    display: flex;
    justify-content: center;
}

.checkout-footer {
    display: flex;
    /* justify-self: ; */
    background: none !important;
    font-size: 18px;
    margin-left: 10px;
}

.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto';
    flex-grow: 1;
}

.span {
    color: blue;
}

.cont {
    background-color: white;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
}

.payment-details {
    color: black;
    font-size: 20px;
    font-family: "Roboto";
    font-weight: bolder;
    align-self: flex-start;

}

.hr-line {
    border-bottom: 1px solid lightgray;
}

.line {
    height: 100%;
    width: 1px;
    background-color: lightslategray;
    box-shadow: 5px 0 1px 2px #898f91;
    margin-right: 13px;
}

.new {
    background-color: #f2f5f7;
    align-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    align-self: center;
    justify-self: center;
    padding: 10px;
    overflow: hidden;
}

.table1 {
    width: 90%;

    align-self: center;
    justify-self: center;
    border: none;
    border-collapse: collapse;
    padding: 10px;
    padding-right: 20px;
    margin: 30px;
}

.payment-container {
    display: flex;
    flex-direction: column;
    padding: 10px;
    /* margin-top:43px; */
    box-shadow: none;
    width: 40%;
}

.last-container {
    font-size: 32px;
}

.paragraph {
    align-self: center;
}

.table-heading {
    background-color: #e4ecf5;
}

@media (max-width: 600px) {
    
    .middle-container {
        flex-direction: column;
        border:none;
    }
    .table-container {
        width: 100%;
        border: 0px;
        border-radius: 0px;
    }
    .payment-details {
        color: black;
        font-size: 20px;
        font-family: "Roboto";
        font-weight: bolder;
        align-self: flex-start;
    }
    .payment-container {
        width: 100%;
    }
}

@media (max-width: 767px) {
    .button-container {
        flex-direction: column;
    }
}


`, "",{"version":3,"sources":["webpack://./src/components/checkout/Checkout.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;;IAE/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;;AAE1B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,gCAAgC;IAChC,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;;IAEV,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,eAAe;QACf,qBAAqB;QACrB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".background {\n    color: white;\n    background-color: black;\n    width: 90vw;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.checkout-page-container {\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n.middle-container {\n    display: flex;\n    /* flex-direction: column; */\n    justify-content: space-around;\n    background-color: white;\n    font-family: \"Roboto\";\n    border:1px solid #DDDDDD;\n    padding: 8px;\n    border-radius: 6px;\n\n}\n\n.middle-container1 {\n    display: flex;\n    background-color: white;\n    margin-bottom: 6px;\n    margin-right: 8px;\n    margin-top: 10px;\n\n}\n\n.heading {\n    font-size: 20px;\n    font-family: \"Roboto\";\n    color: black;\n    align-self: flex-start;\n}\n\n.table-container {\n    /* background-color: #e6eff0; */\n\n    /* padding:30px; */\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    /* background-color: red; */\n    width: 60%;\n    height: auto;\n    /* box-shadow: 0px 1px 5px 1px black; */\n    border-radius: 1px;\n\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n}\n\n.checkout-footer {\n    display: flex;\n    /* justify-self: ; */\n    background: none !important;\n    font-size: 18px;\n    margin-left: 10px;\n}\n\n.main-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Roboto';\n    flex-grow: 1;\n}\n\n.span {\n    color: blue;\n}\n\n.cont {\n    background-color: white;\n    margin-right: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.payment-details {\n    color: black;\n    font-size: 20px;\n    font-family: \"Roboto\";\n    font-weight: bolder;\n    align-self: flex-start;\n\n}\n\n.hr-line {\n    border-bottom: 1px solid lightgray;\n}\n\n.line {\n    height: 100%;\n    width: 1px;\n    background-color: lightslategray;\n    box-shadow: 5px 0 1px 2px #898f91;\n    margin-right: 13px;\n}\n\n.new {\n    background-color: #f2f5f7;\n    align-content: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    align-self: center;\n    justify-self: center;\n    padding: 10px;\n    overflow: hidden;\n}\n\n.table1 {\n    width: 90%;\n\n    align-self: center;\n    justify-self: center;\n    border: none;\n    border-collapse: collapse;\n    padding: 10px;\n    padding-right: 20px;\n    margin: 30px;\n}\n\n.payment-container {\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    /* margin-top:43px; */\n    box-shadow: none;\n    width: 40%;\n}\n\n.last-container {\n    font-size: 32px;\n}\n\n.paragraph {\n    align-self: center;\n}\n\n.table-heading {\n    background-color: #e4ecf5;\n}\n\n@media (max-width: 600px) {\n    \n    .middle-container {\n        flex-direction: column;\n        border:none;\n    }\n    .table-container {\n        width: 100%;\n        border: 0px;\n        border-radius: 0px;\n    }\n    .payment-details {\n        color: black;\n        font-size: 20px;\n        font-family: \"Roboto\";\n        font-weight: bolder;\n        align-self: flex-start;\n    }\n    .payment-container {\n        width: 100%;\n    }\n}\n\n@media (max-width: 767px) {\n    .button-container {\n        flex-direction: column;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
